<template>
  <div
    :class="wrapperClass"
  >
    <ul
      class="error-text"
      :class="{ 'mb-0': marginFlg }"
    >
      <li
        class="mb-error-message error"
      >
        <span v-html="errors[0]" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    // 複数エラーが入った配列を受け取っても12行目で1つしか表示させない
    errors: {
      type: Array,
      default() {
        return [];
      }
    },
    wrapperClass: {
      type: String,
      default: ""
    },
    marginFlg: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
</style>
